import axios from 'axios'
import HTTP from './http'

export default {
    addAgency: payload => axios.post(HTTP.ADD_NEW_AGENCT, { payload }),
    getAgency: params => axios.get(HTTP.VALIDATE_LICENSE, { params })
}